import { PieceFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { useLocaleLink } from '@/ui/hooks/useLocaleLink';
import { extractComponentFromChunk } from '@/ui/utils/tiles';
import Link from 'next/link';
import React from 'react';
import { buildTrackingId } from '@/utils/tracking-helper';
import { slugify } from '@/utils/url-helper';
import { resolveLinkUrlFromChunk } from '../../utils';

export default function HeaderLinkListComponent({
  components,
  setIsOpen,
  trackingPrefix,
}: Readonly<{
  components: PieceFragment['components'];
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  trackingPrefix?: string;
}>) {
  const { localizedLink } = useLocaleLink();
  const links = extractComponentFromChunk(components, 'links', 'ContentChunkContent')?.chunks;

  return (
    <div className="space-y-5">
      {links?.map((link, idx) => {
        const title = extractComponentFromChunk(link, 'title', 'SingleLineContent')?.text;
        const linkUrl = resolveLinkUrlFromChunk(link, localizedLink);

        if (!linkUrl) {
          return null;
        }

        const navLinkTrackingId = buildTrackingId(trackingPrefix, title);

        return (
          <Link
            key={`${slugify(linkUrl)}-${idx}`}
            className="block text-lg font-bold hover:underline"
            href={linkUrl}
            onClick={() => setIsOpen(false)}
            data-tile-element-id={navLinkTrackingId}
          >
            {title}
          </Link>
        );
      })}
    </div>
  );
}
